import { render, staticRenderFns } from "./post.component.html?vue&type=template&id=95475ae4&"
import script from "./post.component.ts?vue&type=script&lang=ts&"
export * from "./post.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports